import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isRtlLanguage } from '@core/constants/app-languages';
import { AppTranslateLanguageService } from '@core/services/app-translate-language.service';

@Injectable({ providedIn: 'root' })
export class DirectionService {
  private readonly translate = inject(TranslateService);
  private readonly langService = inject(AppTranslateLanguageService);

  readonly isRtl = signal(false);

  constructor() {
    const initial = this.translate.getCurrentLang() || this.langService.getStoredLanguage();
    this.apply(initial);
    this.translate.onLangChange.subscribe((event) => this.apply(event.lang));
  }

  private apply(lang: string): void {
    const rtl = isRtlLanguage(lang);
    const html = document.documentElement;
    html.dir = rtl ? 'rtl' : 'ltr';
    html.lang = lang;
    this.isRtl.set(rtl);
  }
}
